import React from 'react';
import { Link } from 'react-router-dom';
import { CatHeadline } from '../components/component';

import { JiLogoBalls } from '../components/jptr-icons';

import xXx from '../base/images/screenshots/ss-crvlk-dark-700x494px.png';
import xXx2 from '../base/images/screenshots/ss-cldrp-dark-700x550px.png';
import xXx4 from '../base/images/screenshots/ss-lkswp-dark-700x648px.png';

import './home.css';

export default function Cntntadios() {
    return (
        <div className='flx-Vc-6' style={{ paddingTop: '2em', paddingBottom: '4em' }}>

            <div className='iflx-Hc-4'>
                <div className='iflx-Hc-1' style={{ maxWidth: '180px' }}>
                    <JiLogoBalls className="home-ico-1"/>
                </div>
                <div className='flx-Vl-1 nully'>
                    <CatHeadline name="Planet Jupiter" />
                    <h3>Your Colorserver in the cloud.</h3>
                    <p>
                        Use the API or this website to convert images from one Colorspace to another. Everythink is
                        possible and no more than "3 clicks" away.
                    </p>
                    <h4>Try it now!</h4>
                    <p>
                        In most cases it will be a devicelink, in special cases an abstract profile. These transformations are
                        highly precise and can be used in a wide range of applications.
                    </p>
                </div>
            </div>


            <div className='iflx-Hc-6'>
                
                <div className='flx-Vl-1 nully'>
                    <CatHeadline name="What is a link?" />
                    <h3>Connector and transfomer between colorspaces.</h3>
                    <p>
                        In most cases it will be a devicelink, in special cases an abstract profile. These transformations are
                        highly precise and can be used in a wide range of applications.
                    </p>
                    <p>
                        So why a link instead of a profile? A link is a profile, but it is a one-way profile. This
                        means that the transformation is not reversible. It makes thinks easier and offers the possibility
                        to appy further exeptions to the transformation, that are not that simple when using a standart
                        output profile, rendering intent and a profile connection space.
                    </p>
                    <p>
                        Based on my experience, I can say that a link is a powerful tool.
                    </p>
                </div>
                <img src={xXx4} className='home-img-1' alt="Curvelink Screenshot" />
            </div>

            <div className='iflx-Hc-6'>
                <div className='flx-Vl-1 nully'>
                    <CatHeadline name="Links..." />
                    <h3>Spy + Curve + Swap  = Merge</h3>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
                        et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                        aliquip ex ea commodo consequat. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia
                        deserunt mollit anim id est laborum.
                    </p>
                    <div className='unolist'>
                        <li><Link to='/lkswp'><strong>Swap</strong></Link> Change the channel of an image.</li>
                        <li><Link to='/lkcrv'><strong>Curve</strong></Link> Apply a curve to an image.</li>
                        <li><Link to='/lkspy'><strong>Spy</strong></Link> Spy the color channels of an image.</li>
                        <li><Link to='/lkmrg'><strong>Merge</strong></Link> Combine multiple links.</li>
                    </div>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
                        et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                        aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
                        dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
                        officia deserunt mollit anim id est laborum.
                    </p>
                </div>
                <img src={xXx} className='home-img-2' alt="Curvelink Screenshot" />

            </div>

            <div className='iflx-Hc-6'>
                <img src={xXx2} className='home-img-3' alt="Curvelink Screenshot" />
                <div className='flx-Vl-1 nully'>
                    <CatHeadline name="Convert" />
                    <h3>Let´s do it!</h3>
                    <p>
                        Lorem ipsum odor amet, consectetuer adipiscing elit. Lectus interdum eleifend per aliquam
                        suspendisse egestas eleifend. Efficitur in conubia viverra pretium dictum class malesuada dictumst.
                    </p>
                    <div className='unolist'>
                        <li><Link to='/cldrp'><strong>convert</strong></Link> Try it now!</li>
                    </div>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
                        et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                        aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
                        dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
                        officia deserunt mollit anim id est laborum.
                    </p>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
                        et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                        aliquip ex ea commodo consequat. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
                        officia deserunt mollit anim id est laborum.
                    </p>
                </div>
            </div>

            <div className='flx-Hc'>
                <div className='flx-Vl-1 nully'>
                    <CatHeadline name="And next?" />
                    <h3>We're open to your ideas.</h3>
                    <p>
                        What you see here is just the beginning. We are open to your ideas and suggestions. We are happy to
                        hear from you. Just send us an email to <a href='mailto:XXXXXXXXXXXXXXXXXXXXXXXXX'>MAIL</a> and we
                        will get back to you as soon as possible.
                    </p>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
                        et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                        aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
                        dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
                        officia deserunt mollit anim id est laborum.
                    </p>
                    <p>Have fun on your ride though the colorspace.</p>
                </div>
            </div>

        </div>
    );
}